/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ParentBehaviorOptionsModel } from '../../models/parent-behavior-options-model';

export interface GetBehaviorOptions$Params {
  patientID?: number;
}

export function GetBehaviorOptions(http: HttpClient, rootUrl: string, params?: GetBehaviorOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<ParentBehaviorOptionsModel>> {
  const rb = new RequestBuilder(rootUrl, GetBehaviorOptions.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ParentBehaviorOptionsModel>;
    })
  );
}

GetBehaviorOptions.PATH = '/api/Parent/GetBehaviorOptions';
